import React from 'react'
import { Route, Redirect } from 'react-router'
import Loadable from 'react-loadable'
import loading from 'components/ui/Loader/Loader'


const WelcomePage = Loadable({ loader: () => import('layers/welcome/pages/WelcomePage/WelcomePage'), loading })


export default (links) => (
  <Route>
    <Route path={links.root} component={WelcomePage} />

    <Redirect path={`${links.root}/*`} to={links.root} />
  </Route>
)
